import * as React from 'react';

import AppMessage from 'bundles/teach-course/components/AppMessage';

import _t from 'i18n!nls/teach-course';

type Props = {
  className?: string;
};

const AppLoadingMessage = (props: Props) => {
  return <AppMessage heading={_t('Loading...')} className={props.className} />;
};

export default AppLoadingMessage;
